// React Router future flags configuration
import { UNSAFE_ENHANCE_TRANSITION_CONTEXT, UNSAFE_mapRouteProperties } from 'react-router-dom';

// Set future flags to opt-in to React Router v7 behavior
export const FUTURE_FLAGS = {
  v7_startTransition: true,
  v7_relativeSplatPath: true
};

// Apply future flags to React Router
if (typeof window !== 'undefined') {
  window.__reactRouterFutureFlags = FUTURE_FLAGS;
}

export default FUTURE_FLAGS; 